import React from 'react';
import { Modal } from 'react-bootstrap'
import EditarPinUsuarioComercio from './EditarPinUsuarioComercio'

class EditarPinUsuarioComercioModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Editar Usuario Comercio
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditarPinUsuarioComercio userToken={this.props.userToken} id={this.props.id} />
                </Modal.Body>
            </Modal>
        );
    }
}

export default EditarPinUsuarioComercioModal;